<template>
  <table>
    <thead>
    <tr>
      <th rowspan="2" width="22%">평가구분</th>
      <th rowspan="2" width="52%">위험요인</th>
      <th colspan="3" width="26%">개선사항</th>
    </tr>
    <tr>
      <th>계</th>
      <th>완료</th>
      <th>미완료</th>
    </tr>
    </thead>
    <tbody>
      <tr v-if="riskList.length === 0">
        <td class="head-td"></td>
        <td class="text-center value-td">계</td>
        <td class="text-center value-td">0</td>
        <td class="text-center value-td">0</td>
        <td class="text-center value-td">0</td>
      </tr>
      <template v-for="(item, index) in riskList">
        <tr v-if="index === 0">
          <td class="head-td"></td>
          <td class="text-center value-td">계</td>
          <td class="text-center value-td">{{ allTotal(riskList) }}</td>
          <td class="text-center value-td">{{ allCompleted(riskList) }}</td>
          <td class="text-center value-td">{{ allIncompleted(riskList) }}</td>
        </tr>
        <tr v-if="index === 0 || riskList[index - 1].evaluation !== item.evaluation">
          <td v-if="index === 0 || riskList[index - 1].evaluation !== item.evaluation" :rowspan="countRows(item.evaluation) + 1" class="head-td">
            {{ item.evaluation }}
          </td>
          <td class="total-td">소계</td>
          <td class="total-td">{{ countTotal(item.evaluation) }}</td>
          <td class="total-td">{{ countCompleted(item.evaluation) }}</td>
          <td class="total-td">{{ countIncompleted(item.evaluation) }}</td>
        </tr>
        <tr>
          <td class="value-td">{{ item.harmfulRisk }}</td>
          <td class="text-center value-td">{{ item.total }}</td>
          <td class="text-center value-td">{{ item.completed }}</td>
          <td class="text-center value-td">{{ item.incompleted }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "RiskEvaluationTable",
  props:{
    riskList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {

    // 테이블 그룹용
    countRows(evaluation) {
      return this.riskList.filter((item) => item.evaluation === evaluation).length;
    },
    countTotal(evaluation) {
      return this.riskList
        .filter((item) => item.evaluation === evaluation)
        .reduce((acc, item) => acc + item.completed + item.incompleted, 0);
    },
    countCompleted(evaluation) {
      return this.riskList
        .filter((item) => item.evaluation === evaluation)
        .reduce((acc, item) => acc + item.completed, 0);
    },
    countIncompleted(evaluation) {
      return this.riskList
        .filter((item) => item.evaluation === evaluation)
        .reduce((acc, item) => acc + item.incompleted, 0);
    },
    // 테이블 전체용
    allTotal(riskList) {
      return riskList.reduce((total, item) => total + item.total, 0);
    },
    allCompleted(riskList) {
      return riskList.reduce((total, item) => total + item.completed, 0);
    },
    allIncompleted(riskList) {
      return riskList.reduce((total, item) => total + item.incompleted, 0);
    },
  }
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    text-align: center;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    background: #f9f9f9;
    border: 1px solid #cdcdcd;
    padding: 10px 0;

    &:first-child {
      padding: 0;
    }
  }

  td {
    border: 1px solid #cdcdcd;
    padding: 7px;
  }
}

.check::v-deep {
  justify-content: center !important;
  span {
    margin: 0;
  }
}

.head-td {
  text-align: center;
  background-color: #f9f9f9;
}
.total-td {
  text-align: center;
  background-color: #FFF6E6;
}
.value-td {
  background-color: #ffffff;
}
</style>
